import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { NgcCookieConsentService, NgcInitializationErrorEvent, NgcInitializingEvent, NgcNoCookieLawEvent, NgcStatusChangeEvent } from 'ngx-cookieconsent';
import { Subscription } from 'rxjs/internal/Subscription';
import {NgxGoogleAnalyticsModule,NgxGoogleAnalyticsRouterModule} from 'ngx-google-analytics';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { MatDialog } from '@angular/material/dialog';
import { WelcomePopupComponent } from './welcome-popup/welcome-popup.component';

declare let $: any;
declare var gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {

    //keep refs to subscriptions to be able to unsubscribe later

    //keep refs to subscriptions to be able to unsubscribe later
  private popupOpenSubscription!: Subscription;
  private popupCloseSubscription!: Subscription;
  private initializingSubscription!: Subscription;
  private initializedSubscription!: Subscription;
  private initializationErrorSubscription!: Subscription;
  private statusChangeSubscription!: Subscription;
  private revokeChoiceSubscription!: Subscription;
  private noCookieLawSubscription!: Subscription;
  private routerSubscription: Subscription;
  location: string;
  isDialogOpen = false;
  
    constructor(private router: Router,private cookieService: NgcCookieConsentService,private goolgeservice: GoogleAnalyticsService, private dialog: MatDialog) {}

    //constructor(private router: Router) {}

    ngOnInit():void{

      this.openWelcomePopup();

      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          (window as any).gtag('set', 'page', event.urlAfterRedirects);
          (window as any).gtag('send', 'pageview');
        }
      });

        this.recallJsFuntions();
         // subscribe to cookieconsent observables to react to main events
    this.popupOpenSubscription = this.cookieService.popupOpen$.subscribe(
        () => {
          // you can use this.cookieService.getConfig() to do stuff...
        });
  
      this.popupCloseSubscription = this.cookieService.popupClose$.subscribe(
        () => {
          // you can use this.cookieService.getConfig() to do stuff...
        });
  
      this.initializingSubscription = this.cookieService.initializing$.subscribe(
        (event: NgcInitializingEvent) => {
          // the cookieconsent is initilializing... Not yet safe to call methods like `NgcCookieConsentService.hasAnswered()`
          console.log(`initializing: ${JSON.stringify(event)}`);
        });
      
      this.initializedSubscription = this.cookieService.initialized$.subscribe(
        () => {
          // the cookieconsent has been successfully initialized.
          // It's now safe to use methods on NgcCookieConsentService that require it, like `hasAnswered()` for eg...
          console.log(`initialized: ${JSON.stringify(event)}`);
        });
  
      this.initializationErrorSubscription = this.cookieService.initializationError$.subscribe(
        (event: NgcInitializationErrorEvent) => {
          // the cookieconsent has failed to initialize... 
          console.log(`initializationError: ${JSON.stringify(event.error?.message)}`);
        });
  
      this.statusChangeSubscription = this.cookieService.statusChange$.subscribe(
        (event: NgcStatusChangeEvent) => {
          let isConsentGiven = event.status;

          if (isConsentGiven=='allow') {
        // Imposta il cookie di consenso
          //his.cookieService2.set('analytics_consent', 'true', 365);
         // this.goolgeservice.startTracking();

        // Carica il codice di tracciamento di Google Analytics (gtag.js)
        // Sostituisci "UA-XXXXXXXXX" con il tuo ID di tracciamento reale
        // Questo codice deve essere personalizzato per la tua implementazione di Google Analytics
        gtag('config', 'G-3YZ1PCMZEE');
        //gtag('config', 'G-3YZ1PCMZEE');
    }else if(isConsentGiven=='deny'){
      window['ga-disable-G-3YZ1PCMZEE'] = true;
    }
          // you can use this.cookieService.getConfig() to do stuff...
        });
  
      this.revokeChoiceSubscription = this.cookieService.revokeChoice$.subscribe(
        () => {
          console.log(`initializing: ${JSON.stringify(event)}`);
          // you can use this.cookieService.getConfig() to do stuff...
        });
  
        this.noCookieLawSubscription = this.cookieService.noCookieLaw$.subscribe(
        (event: NgcNoCookieLawEvent) => {
          console.log(`initializing: ${JSON.stringify(event)}`);
          // you can use this.cookieService.getConfig() to do stuff...
        });

    }

    openWelcomePopup(): void {
      this.isDialogOpen = true;
      const dialogRef = this.dialog.open(WelcomePopupComponent, {
              width: '445px',
              panelClass: 'custom-dialog-container'
      });

      dialogRef.afterClosed().subscribe(() => {
        this.isDialogOpen = false;
      });
    }

    recallJsFuntions() {
        this.router.events
        .subscribe((event) => {
            if ( event instanceof NavigationStart ) {
                $('.preloader').fadeIn('slow');
            }
        });
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            $.getScript('../assets/js/main.js');
            $('.preloader').fadeOut('slow');
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

    ngOnDestroy() {
        // unsubscribe to cookieconsent observables to prevent memory leaks
        this.popupOpenSubscription.unsubscribe();
        this.popupCloseSubscription.unsubscribe();
        this.initializingSubscription.unsubscribe();
        this.initializedSubscription.unsubscribe();
        this.initializationErrorSubscription.unsubscribe();
        this.statusChangeSubscription.unsubscribe();
        this.revokeChoiceSubscription.unsubscribe();
        this.noCookieLawSubscription.unsubscribe();
      }
}